<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useI18n } from 'vue-i18n';
import Logo from 'next/icon/Logo.vue';

const { accountScopedRoute } = useAccount();
const { t } = useI18n();

const menuItems = computed(() => [
  { label: t('SIDEBAR.INBOX'), icon: 'i-lucide-inbox', to: accountScopedRoute('inbox_view') },
  { label: t('SIDEBAR.CONVERSATIONS'), icon: 'i-lucide-message-circle', to: accountScopedRoute('home') },
  { label: t('SIDEBAR.CONTACTS'), icon: 'i-lucide-contact', to: accountScopedRoute('contacts_dashboard_index') },
  { label: t('SIDEBAR.REPORTS'), icon: 'i-lucide-chart-spline', to: accountScopedRoute('account_overview_reports') },
]);
</script>

<template>
  <header class="h-24 w-full flex-shrink-0 bg-white/5 border-b border-white/10 flex items-center px-12 pt-4 z-50">
    <div class="flex items-center gap-6 mr-10">
      <div class="flex items-center justify-center size-12 rounded-2xl bg-white/60 shadow-glass border border-white/40">
        <Logo class="size-8 text-n-brand" />
      </div>
      <div class="h-8 w-px bg-white/10" />
    </div>

    <nav class="flex items-center gap-8 flex-grow">
      <RouterLink
        v-for="item in menuItems"
        :key="item.label"
        :to="item.to"
        class="flex items-center gap-3 px-6 py-2.5 rounded-2xl transition-all duration-500 group"
        active-class="bg-white/70 shadow-glass text-n-brand scale-105"
        inactive-class="hover:bg-white/30 text-n-slate-12 hover:text-n-brand"
      >
        <span :class="[item.icon, 'size-6 transition-transform duration-500 group-hover:scale-110']" />
        <span class="text-sm font-bold uppercase tracking-wider">{{ item.label }}</span>
      </RouterLink>
    </nav>
  </header>
</template>

<style scoped>
.no-scrollbar::-webkit-scrollbar { display: none; }
.no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
</style>
